import CheckBox, { ReduxFormWrapper } from './Container';

export default CheckBox;
export {
  ReduxFormWrapper as CheckBox
};
